import { project } from "../../system/types/project/project";
import { PROJECT_ACTIONS } from "./types"

export const setProjectId = (id: string) => {
    return {
        type: PROJECT_ACTIONS.setProjectId,
        payload: id,
    };
};

export const setProjectData = (data: project) => {
    return {
        type: PROJECT_ACTIONS.setProjectData,
        payload: data,
    }
};

export const setProjectPageCommand = (command: string) => {
    return {
        type: PROJECT_ACTIONS.setPageCommand,
        payload: command,
    }
};

export const setProjectPageCommandId = (commandID: string) => {
    return {
        type: PROJECT_ACTIONS.setPageCommandID,
        payload: commandID,
    }
};

export const setProjectPageCommandSubSelect = (commandID: string) => {
    return {
        type: PROJECT_ACTIONS.setPageCommandSubSelect,
        payload: commandID,
    }
};

export const clearProjectData = () => {
    return {
        type: PROJECT_ACTIONS.clearProjectData
    }
};
